var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#222b45;}.b{fill:#454f63;}.c{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15,20H3a3,3,0,0,1-3-3V5A3,3,0,0,1,3,2H4V1A1,1,0,0,1,6,1V2h6V1a1,1,0,0,1,2,0V2h1a3,3,0,0,1,3,3V17A3,3,0,0,1,15,20ZM2,11v6a1,1,0,0,0,1,1H15a1,1,0,0,0,1-1V11ZM3,4A1,1,0,0,0,2,5V9H16V5a1,1,0,0,0-1-1H14V5a1,1,0,0,1-2,0V4H6V5A1,1,0,0,1,4,5V4ZM13,15H9a1,1,0,0,1,0-2h4a1,1,0,1,1,0,2ZM5,15a1,1,0,1,1,1-1A1,1,0,0,1,5,15Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15,20H3a3,3,0,0,1-3-3V5A3,3,0,0,1,3,2H4V1A1,1,0,0,1,6,1V2h6V1a1,1,0,0,1,2,0V2h1a3,3,0,0,1,3,3V17A3,3,0,0,1,15,20ZM2,11v6a1,1,0,0,0,1,1H15a1,1,0,0,0,1-1V11ZM3,4A1,1,0,0,0,2,5V9H16V5a1,1,0,0,0-1-1H14V5a1,1,0,0,1-2,0V4H6V5A1,1,0,0,1,4,5V4ZM13,15H9a1,1,0,0,1,0-2h4a1,1,0,1,1,0,2ZM5,15a1,1,0,1,1,1-1A1,1,0,0,1,5,15Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c177cf74bdea39364a6ee13b374f873e.svg";
export { ForwardRef as ReactComponent };